/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-underscore-dangle */
import React, { useState } from 'react';
import moment from 'moment';
import BiddingHeaderNew from 'components/atoms/bidding_header_new';
import ListItemIminencia from 'components/atoms/list_item_iminencia';
import MapLink from 'components/atoms/map_link';
import PhoneCard from 'components/atoms/phone_card';
import ManagementButton from 'components/atoms/management_button/management_button';
import { ApplicationState } from 'store';
import { useSelector } from 'react-redux';
import RobotCreateProposalButton from 'components/atoms/robot_proposal_button';
import MonitoreButton from 'components/atoms/monitore_button';
import { PanelState } from 'store/modules/panel_store/types';
import MonitoringPortals from 'services/monitoring_portals';
import ImminenceDate from 'components/atoms/imminence_date';
import ImminanceCommentsList from 'components/organisms/imminance_comments_list';
import _ from 'underscore';
import RobotComprasnetWarning from 'components/atoms/robot_comprasnet_warning';
import { ImminenceState } from 'store/modules/get_dados_imminence_store/types';
import ManagementRemoveBidding from 'components/atoms/management_remove_bidding';
import { ManagementState } from 'store/modules/management_store/types';
import ClipboardIcon from 'components/atoms/clipboard_icon';
import ModalOrganDetails from 'components/molecules/modal_organ_details';
import createTrack from 'services/actions/tracker_actions';
import { ContractItemTypes } from 'store/modules/contracts_store/types';
import iconClock from 'assets/images/icon-clock.svg';
import ManagementTask from '../management_task';
import BiddingAttachmentList from '../bidding_attachment_list';
import { PortalImage } from '../monitoring_portals_list';
import { Container } from './styles';

interface BiddingItemImminenceProps {
  biddingImminence: any;
  biddingIndex: number;
  isChecked: boolean;
  toggleSelectedBiddings: (id: number, updateAll?: boolean) => void;
}

const BiddingItemImminence = (props: BiddingItemImminenceProps) => {
  const { toggleSelectedBiddings, biddingImminence, biddingIndex, isChecked } = props;
  const [modalManagementTaskOpened, setModalManagementTaskOpened] = useState<boolean>(false);
  const [modalRobotWarningOpened, setModalRobotWarningOpened] = useState<boolean>(false);
  const [modalRemoveBiddingOpened, setModalRemoveBiddingOpened] = useState<boolean>(false);
  const [modalOrganDetailsOpened, setModalOrganDetailsOpened] = useState<boolean>(false);
  const [BiddingInfoToggle, setBiddingInfoToggle] = useState<boolean>(false);
  const [statusTwoDays, setStatusTwoDays] = useState<boolean>(false);
  const [statusOneDay, setStatusOneDay] = useState<boolean>(false);
  const [statusDay, setStatusDay] = useState<boolean>(false);
  const { management } = useSelector<ApplicationState, ManagementState>(
    (state) => state.session.management,
  );

  const [taskType, setTaskType] = useState<string>('');
  const portals = MonitoringPortals();

  const { panel } = useSelector<ApplicationState, PanelState>((state) => state.session.panel);

  const { get_imminence } = useSelector<ApplicationState, ImminenceState>(
    (state) => state.session.get_imminence,
  );

  const ALLOWED_ROBOT_PORTALS = [
    'Licitanet',
    'BLL Compras',
    'Bolsa Nacional de Compras (BNC)',
    'ComprasNet',
    'Portal de Compras Publicas',
    'ComprasNet DL',
  ];

  // O modal lê o shape de contrato (_source.orgao aninhado) e a iminência traz os campos
  // achatados. edital_site vai vazio de propósito: o índice não tem esse campo, e o modal
  // só esconde o bloco "Site" quando a string é exatamente ''.
  const organDetails = {
    _source: {
      orgao_id: biddingImminence?._source?.orgao_id,
      orgao: {
        nome: biddingImminence?._source?.orgao_nome,
        uasg: biddingImminence?._source?.orgao_uasg,
        endereco: biddingImminence?._source?.orgao_endereco,
        cidade: biddingImminence?._source?.orgao_cidade,
        estado: biddingImminence?._source?.orgao_estado,
        edital_site: '',
      },
    },
  } as unknown as ContractItemTypes;

  const totalManagedTasks = (bidding_id: number) => {
    return (
      management.managed.find((managed) => managed.id === Number(bidding_id))
        ?.total_managed_opened_tasks || 0
    );
  };

  return (
    <Container className="row mt-5">
      {get_imminence?.view_panel === 'has_imminence' && (
        <span className="badge badge-imminence ml-5 d-print-none">Iminência de deserta</span>
      )}
      <div className="col-12 p-0">
        <div
          className={`card shadow bidding rounded position-relative mb-5 border-top-0 ${
            isChecked ? 'bidding_selected' : 'd-print-none'
          }`}
        >
          <BiddingHeaderNew
            biddingId={String(biddingImminence?._source?.id ?? '')}
            biddingIndex={biddingIndex}
            isChecked={isChecked}
            toggleSelected={toggleSelectedBiddings}
            isFavorited={biddingImminence?._source?.favorited}
            contactList={biddingImminence?._source?.favorited_by}
            favoritedSource="imminence"
            situation={biddingImminence?._source?.tipo_agrupamento_nome}
          />
          <div className="card-body p-4">
            <div className="tour-bidding-info">
              <div className="d-flex flex-column mb-2 bidding-info">
                <div className="d-flex">
                  <div className="bidding-info-title fs-16 pr-2 text-nowrap">Objeto:</div>
                  <div
                    className="flex-grow-1 fs-16 mb-2"
                    dangerouslySetInnerHTML={{ __html: biddingImminence?._source?.objeto || '-' }}
                  />
                </div>
              </div>
              <hr />
              <div className="row bidding-info mb-2">
                <div className="col-md-4 d-flex align-items-center">
                  <div className="bidding-info-title mr-2 text-nowrap">Datas:</div>
                  <div className="text-secondary d-flex">
                    <span
                      className={`${
                        (statusTwoDays || statusOneDay) && 'notice-date px-1 text-dark'
                      } ${statusDay && 'bg-danger px-1 text-white'}`}
                    >
                      {!biddingImminence?._source?.datahora_abertura &&
                        !biddingImminence?._source?.datahora_prazo &&
                        !biddingImminence?._source?.datahora_documento &&
                        !biddingImminence?._source?.datahora_retirada &&
                        !biddingImminence?._source?.datahora_visita &&
                        'Não Informadas'}
                      {biddingImminence?._source?.datahora_abertura && (
                        <ImminenceDate
                          date={biddingImminence?._source?.datahora_abertura}
                          dateType="Abertura"
                          setStatusTwoDays={setStatusTwoDays}
                          setStatusOneDay={setStatusOneDay}
                          setStatusDay={setStatusDay}
                        />
                      )}
                      {biddingImminence?._source?.datahora_prazo && (
                        <ImminenceDate
                          date={biddingImminence?._source?.datahora_prazo}
                          dateType="Prazo"
                          setStatusTwoDays={setStatusTwoDays}
                          setStatusOneDay={setStatusOneDay}
                          setStatusDay={setStatusDay}
                        />
                      )}
                      {biddingImminence?._source?.datahora_documento && (
                        <ImminenceDate
                          date={biddingImminence?._source?.datahora_documento}
                          dateType="Documento"
                          setStatusTwoDays={setStatusTwoDays}
                          setStatusOneDay={setStatusOneDay}
                          setStatusDay={setStatusDay}
                        />
                      )}
                      {biddingImminence?._source?.datahora_retirada && (
                        <ImminenceDate
                          date={biddingImminence?._source?.datahora_retirada}
                          dateType="Retirada"
                          setStatusTwoDays={setStatusTwoDays}
                          setStatusOneDay={setStatusOneDay}
                          setStatusDay={setStatusDay}
                        />
                      )}
                      {biddingImminence?._source?.datahora_visita && (
                        <ImminenceDate
                          date={biddingImminence?._source?.datahora_visita}
                          dateType="Visita"
                          setStatusTwoDays={setStatusTwoDays}
                          setStatusOneDay={setStatusOneDay}
                          setStatusDay={setStatusDay}
                        />
                      )}
                    </span>
                    {statusTwoDays && (
                      <span className="title-relogio ml-2"> 2 dias para encerrar</span>
                    )}
                    {statusOneDay && (
                      <span className="title-relogio ml-2"> 1 dia para encerrar</span>
                    )}
                    {statusDay && (
                      <span className="text-danger ml-2 title-danger"> VENCIMENTO HOJE</span>
                    )}
                    {statusTwoDays || statusOneDay ? (
                      <img src={iconClock} alt="icone de relógio" className="ml-2 mb-1" />
                    ) : (
                      ''
                    )}
                  </div>
                </div>
                <div className="col-md-6 d-flex">
                  <div className="bidding-info-title mr-2 text-nowrap">Órgão:</div>
                  <div>
                    <button
                      type="button"
                      aria-label="Clique para ver licitações já realizadas por esse órgão."
                      data-balloon-pos="up"
                      className="databalloon btn btn-link p-0 text-left break-text border-0"
                      onClick={() => {
                        setModalOrganDetailsOpened(true);
                        createTrack('Card - Clicou no órgão', { fonte: 'imminence' });
                      }}
                    >
                      {!biddingImminence?._source?.orgao_id &&
                        !biddingImminence?._source?.orgao_nome &&
                        '-'}
                      {biddingImminence?._source?.orgao_id}
                      {`${biddingImminence?._source?.orgao_id ? ' - ' : ''}`}
                      {biddingImminence?._source?.orgao_nome}
                      <i className="material-icons bidding-info-icon ml-1">info</i>
                    </button>
                  </div>
                </div>
                <div className="col-md-2">
                  {biddingImminence?._source?.fonte_id > 0 && (
                    <div className="d-flex justify-content-md-end">
                      <PortalImage source_id={biddingImminence?._source?.fonte_id} />
                    </div>
                  )}
                </div>
              </div>
              <div className="row bidding-info mb-2">
                <div className="col-md-4 d-flex align-items-center">
                  <div className="bidding-info-title text-nowrap mr-2">Cidade:</div>
                  <div className="d-flex align-items-center gap-1">
                    <div className="text-secondary">
                      {biddingImminence?._source?.orgao_cidade} -{' '}
                      {biddingImminence?._source?.orgao_estado}
                    </div>
                    <MapLink
                      address={`${biddingImminence._source?.orgao_endereco} ${biddingImminence._source?.orgao_cidade} ${biddingImminence._source?.orgao_estado}`}
                      source="imminence"
                    />
                  </div>
                </div>
                <div className="col-md-8 d-flex">
                  <div className="bidding-info-title text-nowrap mr-2">Edital:</div>
                  <div
                    className="text-secondary"
                    dangerouslySetInnerHTML={{ __html: biddingImminence?._source?.edital || '-' }}
                  />
                </div>
              </div>
              <div
                className={`bidding-hidden-info d-print-block ${
                  BiddingInfoToggle ? 'd-block' : 'd-none'
                }`}
              >
                <div className="row bidding-info mb-2">
                  <div className="col-md-12 d-flex">
                    <div className="bidding-info-title mr-2 text-nowrap">Processo:</div>
                    <div
                      className="text-secondary"
                      dangerouslySetInnerHTML={{
                        __html: biddingImminence?._source?.processo || '-',
                      }}
                    />
                  </div>
                </div>
                <div className="row bidding-info mb-2">
                  <div className="col-md-12 d-flex">
                    <div className="bidding-info-title mr-2 text-nowrap">Observação:</div>
                    <div className="text-secondary">
                      {biddingImminence._source?.observacao || 'Sem Observação'}
                    </div>
                  </div>
                </div>
                <div className="row bidding-info mb-2">
                  <div className="col-md-4 d-flex">
                    <div className="bidding-info-title mr-2 text-nowrap">Telefone:</div>
                    <div className="text-secondary">
                      {biddingImminence.phones?.length > 0 ? (
                        <PhoneCard phones={biddingImminence._source?.telefone} />
                      ) : (
                        '-'
                      )}
                    </div>
                  </div>
                  <div className="col-md-8 d-flex">
                    <div className="bidding-info-title mr-2 text-nowrap">Site:</div>
                    <div className="text-secondary">
                      {!biddingImminence._source?.edital_homepage1 &&
                        !biddingImminence._source?.edital_homepage2 &&
                        '-'}
                      {biddingImminence._source?.edital_homepage1 && (
                        <div>{biddingImminence._source?.edital_homepage1}</div>
                      )}
                      {biddingImminence._source?.edital_homepage2 && (
                        <div>{biddingImminence._source?.edital_homepage2}</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row d-print-none">
              <div className="col-md-12">
                <button
                  type="button"
                  key="btn-bidding-more-info"
                  className="btn btn-sm btn-link font-weight-bold text-left px-0"
                  onClick={() => setBiddingInfoToggle(!BiddingInfoToggle)}
                >
                  {BiddingInfoToggle ? 'Ocultar' : 'Ver mais informações da licitação'}
                </button>
              </div>
            </div>
            <hr className="mt-2" />
            <div className="row bidding-info mb-3 d-print-none">
              <div className="col-md-12">
                <div className="bidding-info-title mr-2 text-nowrap mb-1">Ações:</div>

                <div className="d-flex flex-wrap align-items-center gap-2">
                  {biddingImminence._source?.edicts?.length > 0 && (
                    <BiddingAttachmentList
                      biddingStatusEdital={biddingImminence._source?.edital_status_id}
                      biddingFiles={biddingImminence._source?.edicts}
                    />
                  )}
                  <ManagementButton
                    biddingId={biddingImminence._source?.id}
                    setModalManagementTaskOpened={setModalManagementTaskOpened}
                    setModalRemoveBiddingOpened={setModalRemoveBiddingOpened}
                    setTaskType={setTaskType}
                    isManaged={biddingImminence?._source?.managed}
                    source="imminence"
                  />
                  {biddingImminence._source?.has_electronic_trading && (
                    <MonitoreButton
                      isMonitored={biddingImminence?._source?.monitored_by_user}
                      biddingId={biddingImminence._source?.id}
                      source="imminence"
                    />
                  )}
                  {panel.allow_robot ||
                    (panel?.validate_services?.robo &&
                      portals
                        .filter((portal) => ALLOWED_ROBOT_PORTALS.includes(portal.label))
                        .map((portal) => portal.value)
                        .includes(biddingImminence.electronic_trading?.source_id) && (
                        <RobotCreateProposalButton
                          newLaw={_.isNull(biddingImminence.electronic_trading?.trading_id)}
                          setModalRobotWarningOpened={setModalRobotWarningOpened}
                          bidding={biddingImminence}
                        />
                      ))}
                </div>
              </div>
            </div>
            <hr />
            <ListItemIminencia item={biddingImminence?._source?.itens_imminance} />
            <ImminanceCommentsList
              biddingId={biddingImminence?._source?.id}
              comments={biddingImminence?._source?.comments}
            />
            <div
              className="d-flex justify-content-between align-items-center border-top pt-2 mt-3 text-secondary flex-column flex-md-row"
              style={{ fontSize: '12px' }}
            >
              <div>
                <span className="number-cnl font-weight-bold">Nº Conlicitação:</span>{' '}
                <span>{biddingImminence?._source?.id || '-'}</span>
                <ClipboardIcon
                  value={String(biddingImminence?._source?.id ?? '')}
                  action="Card Licitação - Copiar número conlicitacao"
                />
              </div>
              <div>
                <span>Atualizada em: </span>
                <span>{moment(biddingImminence._source?.modified || '').format('L [às] LT')}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ManagementTask
        modalManagementTaskOpened={modalManagementTaskOpened}
        setModalManagementTaskOpened={setModalManagementTaskOpened}
        bidding={biddingImminence?._source}
        taskType={taskType}
      />
      <ManagementRemoveBidding
        modalRemoveBiddingOpened={modalRemoveBiddingOpened}
        setModalRemoveBiddingOpened={setModalRemoveBiddingOpened}
        biddingId={biddingImminence._source?.id}
        totalOpenedTaks={totalManagedTasks(biddingImminence._source?.id)}
        source="imminence"
      />
      <RobotComprasnetWarning
        setShowModal={setModalRobotWarningOpened}
        showModal={modalRobotWarningOpened}
      />
      {modalOrganDetailsOpened && (
        <ModalOrganDetails
          contract={organDetails}
          setModalOrganDetailsOpened={setModalOrganDetailsOpened}
        />
      )}
    </Container>
  );
};
export default BiddingItemImminence;
